import { AssetHealthActionCostType, CapexSubtype, OpexSubtype } from 'types'

export interface CostTypeHierarchyNode {
  value: string
  label: string
  children?: CostTypeHierarchyNode[]
}

export const COST_TYPE_HIERARCHY: CostTypeHierarchyNode[] = [
  {
    value: AssetHealthActionCostType.OPEX,
    label: 'OPEX',
    children: Object.values(OpexSubtype).map((subtype) => ({
      value: subtype,
      label: subtype,
    })),
  },
  {
    value: AssetHealthActionCostType.CAPEX,
    label: 'CAPEX',
    children: Object.values(CapexSubtype).map((subtype) => ({
      value: subtype,
      label: subtype,
    })),
  },
]

export function formatCostTypeHierarchy(hierarchy: string[]): string {
  return hierarchy.join(' > ')
}

/**
 * Check if a hierarchy is a descendant of another hierarchy
 * Used for filtering and aggregation
 * Example: ["OPEX", "Maintenance"] is descendant of ["OPEX"]
 */
export function isDescendantOf(
  hierarchy: string[],
  parentHierarchy: string[]
): boolean {
  if (parentHierarchy.length >= hierarchy.length) {
    return false
  }

  return parentHierarchy.every((value, index) => hierarchy[index] === value)
}

export function hierarchiesEqual(
  hierarchy1: string[],
  hierarchy2: string[]
): boolean {
  if (hierarchy1.length !== hierarchy2.length) {
    return false
  }
  return hierarchy1.every((value, index) => hierarchy2[index] === value)
}
